import api from './utils/api';

class AvailabilitiesService {
  async listAvailabilities() {
    const result = await api.get('/availabilities');
    return result.data;
  }

  async listModelAvailabilities(id) {
    const result = await api.get(`/model-availability/${id}`);
    return result.data;
  }

  async upsertModelAvailabilities({ availabilityId, startTime, endTime }) {
    const result = await api.put('/model-availability', {
      availabilityId,
      startTime,
      endTime,
    });

    return result.data;
  }

  async deleteModelAvailability(id) {
    const result = await api.delete(`/model-availability/${id}`);
    return result.data;
  }
}

export default new AvailabilitiesService();
